import api, { HttpResponse } from '../utils/api';
import { FilterInfo, CompanyModel, ErrorModel, RestrictedCompanyModel, VisibleCompanyDataModel } from '../common/models/CommonModels';
import { RegisterCompanyModel } from '../register/company/RegisterCompanyModels';
import { RegisteredCompanyModel, RegisteredCompanyDataModel, RegisteredPersonModel } from '../admin/models/CompanyModels';
import { momentToString } from '../utils/dateUtilities';
import { createCompanyFilterUrl } from "./apiFilterUtils";
import * as moment from 'moment';

export async function findCompanyWithRegistrationId(identifier: string): Promise<CompanyModel | undefined | ErrorModel> {
    try {
        const result = await api.get(`api/companies/search/registrationId/${identifier}/`);
        if (result.status === 200) {
            return <CompanyModel>result.data;
        }
        return Promise.resolve(undefined);
    } catch (error) {
        return { message: error };
    }
}

export async function registerCompany(formData: RegisterCompanyModel): Promise<boolean> {
    return await api.post('api/companies', formData).then(data => {

        return data.status === 200;
    }).catch(e => {
        return false;
    });
}

export async function fetchRegisteredCompanies(): Promise<RegisteredCompanyDataModel[] | ErrorModel> {   
    return api.get("api/companies").then((response: HttpResponse) => {
        if (response.status === 200) {
            const data = <any[]>response.data;

            const modified = data.map(item => {
                return {
                    ...item,
                    acceptedAt: moment(item.acceptedAt),
                    registeredAt: moment(item.registeredAt),
                    rejectedAt: moment(item.rejectedAt),
                    employees: item.employees.map((person : RegisteredPersonModel) => Object.assign({}, person, { registeredAt: moment(person.registeredAt)}))
                }
            })

            return Promise.resolve(modified);
        }
        return Promise.resolve([]);
    }).catch(error => {
        return Promise.resolve([]);
    });
}

export async function acceptCompany(companyId: string): Promise<any> {
    return await api.patch("api/companies/accept", { companyId }).then(response => {
        if (response.status === 200) {
            return Promise.resolve(true);
        }

        return Promise.resolve(false);
    }).catch(error => {
        return Promise.resolve(false);
    })
}

export const getRestrictedCompanies = (companyId: string): Promise<RestrictedCompanyModel[]> => {
    return api.get("api/companies/restrictions").then(response => {
        if (response.status === 200) {
            const res: RestrictedCompanyModel[] = <RestrictedCompanyModel[]>response.data;
            return res;
        }

        return [];
    });
}

export const getRestrictionCandidates = (): Promise<RestrictedCompanyModel[]> => {
    return api.get("api/companies/restrictioncandidates").then(response => {
        if (response.status === 200) {
            const res: RestrictedCompanyModel[] = <RestrictedCompanyModel[]>response.data;
            return res;
        }

        return [];
    });
}

export const addVisibilityRestriction = (id: string): Promise<boolean> => {
    return api.post("api/companies/restrictions", { restrictedCompanyId: id, isVisible: false }).then(response => {
        if (response.status === 200) {
            return true;
        }

        return false;
    });
}

export const deleteRestriction = (id: string): Promise<boolean> => {
    return api.post("api/companies/restrictions/delete", { id }).then(response => {
        if (response.status === 200) {
            return true;
        }

        return false;
    });
}

export const deleteCompany = (id: string): Promise<boolean> => {
    return api.delete("api/companies", { id }).then(response => {
        return response.status === 200;
    });
}

export async function rejectCompany(companyId: string): Promise<any> {
    return await api.patch("api/companies/reject", { companyId }).then(response => {
        if (response.status === 200) {
            return Promise.resolve(true);
        }

        return Promise.resolve(false);
    }).catch(error => {
        return Promise.resolve(false);
    })
}

export const getVisibleCompanies = (filters?: FilterInfo): Promise<VisibleCompanyDataModel[]> => {
    const filterUrl = createCompanyFilterUrl(filters);

    return api.get("api/companies/visibleCompanies" + filterUrl).then(response => {
        if (response.status === 200) {
            const res: VisibleCompanyDataModel[] = <VisibleCompanyDataModel[]>response.data;
            return res;
        }

        return [];
    });
}

export async function createPartnerApiKey(companyId: string): Promise<string|null> {
    try {
        const response = await api.post(`api/companies/${companyId}/partnerapikey`);
        if (response.status === 200) {
            return response.data as string;
        }

        return null;
    } catch (error) {
        return null;
    }
}


// WEBPACK FOOTER //
// ./src/api/companyApi.ts